import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './Home';

function Template() {

  return (
    <>
      <Switch>
        <Route
          exact
          path={`/:category+`}
          render={(homeProps) => (
            <Home {...homeProps} />
          )}
        />
        <Route
          exact
          path="/"
          render={(homeProps) => (
            <Home {...homeProps} />
          )}
        />
      </Switch>
    </>
  );
}

export default Template;
